import { turnBlobUrlIntoFile } from "../upload/sagas";

const superagent = require("superagent");

const uploadS3 = async (signedRequest, file) => {
  const formattedFile =
    file instanceof File ? file : await turnBlobUrlIntoFile(file);

  return superagent
    .put(signedRequest)
    .set("Content-Type", "image/jpg")
    .send(formattedFile);
};

export default uploadS3;
